export default "__VITE_ASSET__YWaRd0C9__"